import {omneticApi} from '@dms/api/base';
import {
  GetWatermarkApiResponse,
  UpdateWatermarkApiResponse,
  UpdateWatermarkApiArg,
  GetPreviewApiResponse,
  GetPreviewApiArg,
  GetPreviewFromSettingsApiResponse,
  GetPreviewFromSettingsApiArg,
  PatchAdvertisedVehicleInAdvertisementUpdatedAtApiResponse,
  PatchAdvertisedVehicleInAdvertisementUpdatedAtApiArg,
} from '@dms/api/shared';

export const watermarkApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getWatermark: build.query<GetWatermarkApiResponse, void>({
      query: () => ({url: `/dms/v2/sales/watermark`}),
      providesTags: ['watermark'],
    }),
    updateWatermark: build.mutation<UpdateWatermarkApiResponse, UpdateWatermarkApiArg>({
      query: (queryArg) => ({
        url: `/dms/v2/sales/watermark`,
        method: 'PUT',
        body: queryArg.updateWatermarkRequestBody,
      }),
      invalidatesTags: ['watermark'],
    }),
    getPreview: build.query<GetPreviewApiResponse, GetPreviewApiArg>({
      query: (queryArg) => ({url: `/dms/v2/sales/watermark/preview/${queryArg.vehiclePhotoId}`}),
    }),
    patchAdvertisedVehicleInAdvertisementUpdatedAt: build.mutation<
      PatchAdvertisedVehicleInAdvertisementUpdatedAtApiResponse,
      PatchAdvertisedVehicleInAdvertisementUpdatedAtApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/sales/publishing/vehicle/${queryArg.vehicleId}/advertisement/updated-at`,
        method: 'PATCH',
        body: queryArg.patchAdvertisedVehicleInAdvertisementUpdatedAtRequestBody,
      }),
    }),
    getPreviewFromSettings: build.query<
      GetPreviewFromSettingsApiResponse & {base64Url: string},
      GetPreviewFromSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v2/sales/watermark/settings-preview`,
        params: {
          fileId: queryArg.fileId,
          position: queryArg.position,
          size: queryArg.size,
          fitToImage: queryArg.fitToImage,
        },
      }),
      transformResponse: (response: GetPreviewFromSettingsApiResponse) => ({
        ...response,
        base64Url: `data:image/png;base64, ${response.content}`,
      }),
    }),
  }),
});

export const {
  useGetWatermarkQuery,
  useUpdateWatermarkMutation,
  useGetPreviewQuery,
  useGetPreviewFromSettingsQuery,
  usePatchAdvertisedVehicleInAdvertisementUpdatedAtMutation,
} = watermarkApi;
